const Modulos = Object.freeze({
  FORTES_PESSOAL: 'Pessoal',
  FORTES_RH: 'Rh',
  FORTES_FINANCEIRO: 'Financeiro'
});

export { Modulos }